function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var module; // LICENSE_CODE ZON

'use strict';
/*jslint node:true, react:true, es6: true*/


let is_node = typeof module == 'object' && module.exports && module.children;
if (is_node) ;else ;
define(['react', 'classnames', '/util/util.js', '/svc/account/pub/membership.js'], function (React, cn, zutil, zmembership) {
  const E = {};
  const assign = Object.assign;

  E.format_time = ms => {
    let pad = num => ('000' + num).slice(-2);

    let sec = Math.floor(ms / 1000);
    let days = Math.floor(sec / (60 * 60 * 24));
    sec -= days * 60 * 60 * 24;
    let hours = Math.floor(sec / (60 * 60));
    sec -= hours * 60 * 60;
    let mins = Math.floor(sec / 60);
    sec -= mins * 60;

    if (days == 1 && hours == 0) {
      days = 0;
      hours = 24;
    }

    return (days ? days + 'd ' : '') + (hours || days ? hours + 'h ' : '') + pad(mins) + 'm ' + pad(sec) + 's';
  };

  E.get_plan_display_options = plan => {
    const regular_price = plan.regular_price,
          price = plan.price,
          free_period = plan.free_period,
          renewal_price = plan.renewal_price;
    const show_line_through_regular_price = regular_price && regular_price != price && !free_period;
    return {
      show_line_through_regular_price,
      show_plus_free: free_period,
      show_renewal_billing_label: renewal_price
    };
  };

  const get_price_obj = (plan, currency, {
    days,
    months,
    free_months,
    regular_monthly
  }) => {
    const regular_monthly_price = currency == 'usd' ? regular_monthly && regular_monthly.price : regular_monthly && regular_monthly.currency && regular_monthly.currency[currency] && regular_monthly.currency[currency].price;
    const werf_regular_monthly_price = currency == 'usd' ? regular_monthly && regular_monthly.price : regular_monthly && regular_monthly.currency && regular_monthly.currency[currency] && (regular_monthly.currency[currency].werf_price || regular_monthly.currency[currency].price);
    const price = plan.price,
          renewal_price = plan.renewal_price;
    const werf_price = plan.werf_price || plan.price;
    const werf_renewal_price = plan.werf_renewal_price || plan.renewal_price;
    const regular_price = months && regular_monthly_price ? regular_monthly_price * (months + free_months || 0) : renewal_price;
    const werf_regular_price = months && werf_regular_monthly_price ? werf_regular_monthly_price * (months + free_months || 0) : werf_renewal_price;
    const discount = regular_price ? regular_price - price : null;
    const month_price = months ? werf_price == 83.99 ? 6.99 : +(werf_price / months).toFixed(2) : null;
    const week_price = month_price ? +(month_price / 4).toFixed(2) : null;
    const day_price = days ? +(werf_price / days).toFixed(2) : null;
    const regular_month_price = months && werf_regular_price ? +(werf_regular_price / (months + free_months || 0)).toFixed(2) : null;
    const discount_percent = discount ? Math.round(100 * discount / regular_price) : null;
    const erf_amount = plan.werf_price ? +(plan.price - plan.werf_price).toFixed(2) : null;
    return {
      price,
      werf_price,
      regular_price,
      werf_regular_price,
      month_price,
      week_price,
      day_price,
      regular_month_price,
      discount,
      discount_percent,
      renewal_price,
      werf_renewal_price,
      erf_amount
    };
  };

  E.get_period_units = period => {
    const _ref = zmembership.parse_period(period) || {},
          count = _ref.count,
          unit = _ref.unit;

    const months = unit == 'M' ? count : unit == 'Y' ? 12 * count : 0;
    const days = unit == 'D' ? count : unit == 'W' ? count * 7 : unit == 'M' ? count * 30 : unit == 'Y' ? 365 * count : 0;
    return {
      days,
      months
    };
  };

  const fill_plan_info = (plan, {
    add,
    replace,
    regular_monthly
  } = {}) => {
    const id = plan.id;
    const m = zmembership.parse_period(plan.period);
    if (!m) return;
    const period_count_original = m.count,
          period_type_original = m.unit;
    const period_type = period_type_original;
    const period_name = zmembership.period_unit_names[period_type];
    const period_name_original = period_name;
    let period_count = period_count_original;

    const _E$get_period_units = E.get_period_units(plan.period),
          months = _E$get_period_units.months,
          days = _E$get_period_units.days;

    const _E$get_period_units2 = E.get_period_units(plan.free_period),
          free_months = _E$get_period_units2.months;

    let currency;
    if (E.is_month_on) period_count = months;

    if (plan.currency) {
      currency = {};

      for (const c in plan.currency) {
        const cur = plan.currency[c];
        currency[c] = assign({
          bluesnap: !!cur.bluesnap_id,
          stripe: !!cur.stripe_id,
          paypal: !!cur.paypal_id,
          avangate: !!cur.avangate_id
        }, cur, get_price_obj(cur, c, {
          days,
          months,
          free_months,
          regular_monthly
        }));
      }
    }

    const short_name = zmembership.get_plan_short_name(plan.period);
    return assign({}, add, {
      id,
      short_name,
      name: `${short_name} Plan`,
      period_count,
      period_type,
      period_name,
      every: period_count_original > 1 ? period_count_original + ' ' + period_name_original + 's' : period_name_original,
      currency,
      bluesnap: !!plan.bluesnap_id,
      paypal: !!plan.paypal_id,
      stripe: !!plan.stripe_id,
      avangate: !!plan.avangate_id,
      is_plan: true
    }, zutil.pick(plan, 'type', 'base_plan', 'period', 'avangate_id', 'avangate_product', 'net', 'paypal_id', 'paypal_test_id', 'bluesnap_id', 'bluesnap_test_id', 'bluesnap_ext_id', 'bluesnap_ext_test_id', 'stripe_id', 'stripe_test_id', 'free_period', 'fallback_plan', 'title', 'erf'), get_price_obj(plan, 'usd', {
      days,
      months,
      free_months,
      regular_monthly
    }), replace);
  };

  E.fill_plans_info = (plan_ids, all_plans, {
    discount_base,
    replace_plan,
    add
  }) => {
    let regular_monthly = all_plans.find(p => {
      const search_if = replace_plan && replace_plan[p.id];
      const replace_plan_obj = search_if ? all_plans.find(r => r.id == search_if) : null;
      const period = replace_plan_obj ? replace_plan_obj.period : p.period;
      return discount_base && discount_base == p.id || period.match(/1\s?m/i) && plan_ids.includes(p.id);
    }) || {};

    if (regular_monthly) {
      const search_if = replace_plan && replace_plan[regular_monthly.id];
      const replace_plan_obj = search_if ? all_plans.find(r => r.id == search_if) : null;
      if (replace_plan_obj) regular_monthly = replace_plan_obj;
    }

    let plans = plan_ids.map(id => {
      let replace = replace_plan && replace_plan[id];
      id = replace && replace.id || replace || id;
      replace = replace && typeof replace == 'object' ? replace : {};

      if (id == 'free') {
        return assign({
          period: 'free',
          id: 'free',
          name: 'Free',
          price: 'Free'
        }, {});
      }

      const plan = all_plans.find(p => p.id == id);
      if (!plan) return;
      return fill_plan_info(plan, {
        add,
        regular_monthly,
        replace
      });
    });
    return plans.filter(p => !!p);
  };

  E.Sitepic = class Sitepic extends React.PureComponent {
    constructor(...args) {
      super(...args);

      _defineProperty(this, "state", {
        no_image: false
      });

      _defineProperty(this, "on_img_error", event => {
        event.target.onerror = null;
        this.setState({
          no_image: true
        });
      });

      _defineProperty(this, "on_click", event => this.props.activate(event, this.props));
    }

    render() {
      let state = this.state,
          props = this.props;
      let src = props.image || '';

      if (props.is_landing) {
        src = /netflix\.com\.jpg/.test(props.image) ? props.sitepic_netflix : /fubo\.tv\.png/.test(props.image) ? props.sitepic_fubo : /france\.tv\.png/.test(props.image) ? props.sitepic_france : props.image;
      }

      let sitepic_cls = cn('ui_sitepic2', props.sitepic_class, {
        ui_sitepic2_noimage: state.no_image,
        premium_site: props.premium_site !== undefined && props.premium_site,
        free_site: props.premium_site !== undefined && !props.premium_site,
        ui_sitepic2_unblocking: props.unblocking,
        ui_sitepic2_active: props.unblocking,
        ui_sitepic_disabled: props.disabled,
        ui_sitepic2_orange: props.orange
      });
      let is_shaded = props.is_shaded || state.no_image;
      return /*#__PURE__*/React.createElement("div", {
        className: sitepic_cls
      }, /*#__PURE__*/React.createElement("a", {
        className: "ui_sitepic2_body",
        onClick: this.on_click
      }, /*#__PURE__*/React.createElement("div", {
        className: "ui_status",
        style: {
          display: 'none'
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "ui_status_label"
      })), is_shaded && /*#__PURE__*/React.createElement("div", {
        className: "ui_sitepic2_shade ui_sitepic2_shade_bg_1"
      }, /*#__PURE__*/React.createElement("span", {
        className: "ui_sitepic2_shade_siteurl"
      }, props.link), /*#__PURE__*/React.createElement("div", {
        className: "ui_sitepic2_shade_sitename"
      }, /*#__PURE__*/React.createElement("span", {
        className: "ui_sitepic2_shade_sitename_img"
      }, /*#__PURE__*/React.createElement("img", {
        src: "//favicon.yandex.net/favicon/test.com"
      })), /*#__PURE__*/React.createElement("span", {
        className: "ui_sitepic2_shade_sitename_title"
      }, props.title))), /*#__PURE__*/React.createElement("div", {
        className: "ui_sitepic2_overlay"
      }, /*#__PURE__*/React.createElement("div", {
        className: "sprite"
      }), /*#__PURE__*/React.createElement("div", {
        className: "status"
      }, "Unblocking ", props.title)), /*#__PURE__*/React.createElement("div", {
        className: "ui_sitepic2_promotion"
      }, "Add Hola to unblock ", props.title), /*#__PURE__*/React.createElement("div", {
        className: "ui_sitepic2_img"
      }, /*#__PURE__*/React.createElement("img", {
        src: src,
        onError: this.on_img_error,
        alt: `${props.title} website image`
      }))));
    }

  };

  E.Menu_icon = function Menu_icon({
    img,
    id,
    img_urls = []
  }) {
    return /*#__PURE__*/React.createElement("div", {
      className: cn('menu-icon', 'menu-icon-' + id)
    }, /*#__PURE__*/React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      version: "1.1"
    }, /*#__PURE__*/React.createElement("use", {
      xlinkHref: img_urls[0] || `${img}#${id}_1`
    })), /*#__PURE__*/React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      version: "1.1"
    }, /*#__PURE__*/React.createElement("use", {
      xlinkHref: img_urls[1] || `${img}#${id}_2`
    })));
  };

  return E;
});